export default __webpack_public_path__ + "static/alkemi-logo-white-84e777b4c6fb195db4c429e0d272b6a0.svg";